export default function getTrackingId(route) {
  const base = 'spesial:lyspunkt'
  if (route.name === 'kategori') {
    return `${base}_${dashToUnderscore(route.params.slug)}`
  }

  return `${base}_forside`
}

function dashToUnderscore(str) {
  return str.replace(/-/g, '_')
}
